import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import Modal from 'shared/components/Modal';
import DiscountCodeModal from './DiscountCodeModal';
import Loading from 'shared/components/Loading';
import PurchaseDetails from 'app/components/PurchaseDetails';
import modalStyles from 'shared/components/modalStyles';
import ImageGalleryContainer from 'app/components/ImageGalleryContainer';
import PriceGuide from 'app/components/PriceGuide';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import config from 'shared/config/config';
import PurchaseModal from 'app/components/PurchaseModal';
import PurchaseDisabledModal from 'app/components/PurchaseDisabledModal';
import Viewport from 'app/components/Viewport';
import ImageCropDialog from 'app/components/ImageCropDialog';
import PrintSizeEditsDialog from 'app/components/PrintSizeEditsDialog';

import {
  reKnockOutMoment,
  removeMoment,
  selectMoments,
  unselectMoments,
  clearPurchaseRequest,
  getSelectedPrintSizes,
  getMoments
} from 'shared/actions/cartActions';

import {
  viewCatalog,
  viewReceipt,
  setScrollPosition,
  unselectMoment as unselectKioskMoment
} from 'app/actions/kioskActions';

import {
  setPhotoSwipeMoment,
  showAuthorizeKnockout,
  showCropMoment,
  showPrintSizeEdits
} from 'app/actions/photoSwipeActions';

import {
  trackEvent
} from 'shared/services/Analytics';

import {
  getCurrencySign
} from 'shared/services/PriceService';

import {
  GALLERY_SCREEN,
  CART_SCREEN,
  MARKETPLACE_CHECKOUT_TYPE
} from 'app/utils/Constants';

import {
  getCartMoments,
  getSelectedCount,
  getSelectedMoments,
  getAvailableMomentIds
} from 'shared/selectors/cartSelectors';

import {
  LEGACY_THEME,
  CLUBMED_THEME,
  HPX_THEME
} from 'shared/config/themes';

import SelectedPrintsPreviewModal from './SelectedPrintsPreviewModal';
import AuthorizePinDialog from './AuthorizePinDialog';
import { Dimmer, Loader } from 'semantic-ui-react';

const styles = () => ({
  viewport: {
    position: 'relative',
    float: 'left',
    width: '100%',
    marginTop: '3.75rem',
    minHeight: '100vh'
  },
  momentsPanel: {
    position: 'relative',
    float: 'left',
    width: '72vw',
    minHeight: '100vh',
    marginTop: '4rem',
    background: '#707072'
  },
  orderPanel: {
    position: 'fixed',
    top: '7rem',
    right: 0,
    zIndex: 2,
    width: '27vw',
    minHeight: '100vh',
    boxShadow: '-1px 0 3px 1px rgba(0, 0, 0, 0.1)',
    padding: '1.5rem',
    background: '#fff',
    fontSize: '0.9rem'
  },
  orderPanelContainer: {
    position: 'relative',
    float: 'left',
    width: '100%'
  },
  panelHeader: {
    float: 'left',
    width: '100%',
    fontSize: '1.2rem',
    fontWeight: 700,
    textAlign: 'left',
    margin: config.cart_panel_header_margin,
    color: config.cart_panel_header_font_color,
    fontFamily: config.main_font
  },
  toolbar: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: 6,
    top: config.cart_toolbar_top,
    left: 0,
    right: 0,
    height: '4.8rem',
    background: config.cart_toolbar_bg_color,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    padding: '0.5rem 1rem'
  },
  toolbarLeftColumn: {
    flex: 1,
    minWidth: 0
  },
  cartToolbar: {
    position: 'fixed',
    zIndex: 5,
    top: '7.6rem',
    left: 0,
    right: 0,
    height: '3.3rem',
    background: config.kiosk_toolbar_bg,
    fontFamily: config.sub_font,
    paddingTop: '0.5rem',
    width: '73vw'
  },
  cartToolbarHeader: {
    float: 'left',
    fontSize: '1.2rem',
    fontWeight: 600,
    margin: config.kiosk_toolbar_header_margin,
    color: config.kiosk_toolbar_header_font_color,
    padding: config.kiosk_toolbar_header_padding
  },
  cartToolbarActions: {
    float: 'right',
    marginRight: '1rem',
    color: config.kiosk_toolbar_header_font_color
  },
  cartToolbarAction: {
    float: 'right',
    fontSize: '2rem',
    margin: '0.3rem 0.75rem',
    cursor: 'pointer',
    color: config.kiosk_toolbar_header_font_color
  },
  tapMessage: {
    float: 'left',
    textAlign: 'left',
    fontSize: '0.8rem',
    fontFamily: config.sub_font
  },
  noMoments: {
    background: '#fff',
    border: '1px solid #ddd',
    borderRadius: '3px',
    boxShadow: '0 0 2px #ddd',
    width: '30rem',
    padding: '1rem',
    margin: '5rem auto'
  },
  actions: {
    float: 'right',
    marginTop: '0.5rem'
  },
  completePurchaseButton: {
    float: 'right',
    textAlign: 'center',
    padding: '0.5rem 1.3rem',
    fontWeight: 600,
    background: 'linear-gradient(#4ea4c3, #007aa1)',
    borderRadius: '3px',
    border: 'none',
    color: '#fff',
    fontSize: '16px',
    fontFamily: config.root_font_family
  },
  completePurchaseButton2: {
    float: 'right',
    textAlign: 'center',
    padding: '0.5rem 1.3rem',
    fontWeight: 600,
    background: '#3A8DDE',
    borderRadius: '3px',
    border: 'none',
    color: '#fff',
    marginTop: '0.4rem'
  },
  addImagesButton: {
    float: 'right',
    textAlign: 'center',
    marginRight: '2rem',
    padding: '0.5rem 1.3rem',
    fontSize: '1rem',
    fontWeight: 600,
    borderRadius: '3px',
    background: 'linear-gradient(#ffffff, #f1f1f1)',
    border: '1px solid #dcdcdc',
    color: '#2b8eb0',
    boxShadow: '0 0 0px 5px #2b8eb0',
    fontFamily: config.root_font_family
  },
  priceGuideButton: {
    float: 'right',
    textAlign: 'center',
    marginRight: '1rem',
    padding: '0.5rem 1.3rem',
    fontWeight: 600,
    background: 'linear-gradient(#ffffff, #f1f1f1)',
    borderRadius: '3px',
    border: '1px solid #dcdcdc',
    boxShadow: '0 0 2px #dcdcdc',
    color: '#2b8eb0'
  },
  printSizeButton: {
    float: 'right',
    textAlign: 'center',
    marginRight: '2rem',
    padding: '0.8rem 1.3rem',
    fontWeight: 600,
    background: 'linear-gradient(#ffffff, #f1f1f1)',
    borderRadius: '3px',
    border: '1px solid #dcdcdc',
    boxShadow: '0 0 2px #dcdcdc',
    color: '#2b8eb0'
  },
  priceGuideIcon: {
    marginTop: '-0.2rem',
    marginRight: '0.2rem'
  },
  discountIcon: {
    marginTop: '-0.2rem',
    marginRight: '0.2rem'
  },
  cartCount: {
    float: 'right',
    fontSize: '1.3rem',
    fontWeight: 600,
    marginTop: '-0.2rem',
    marginRight: '0.5rem',
    padding: '0.5rem 0',
    textTransform: 'uppercase',
    color: config.kiosk_cart_count_font_color,
    fontFamily: config.sub_font
  },
  cartCount2: {
    float: 'right',
    fontSize: '1rem',
    marginTop: '0',
    marginRight: '0.5rem',
    padding: '1em 0',
    color: '#3A8DDE',
    fontFamily: config.sub_font,
    fontWeight: 600
  },
  cartIcon: {
    fontSize: '1.8rem',
    marginTop: '-0.2rem',
    marginLeft: '0.4rem',
    marginRight: config.kiosk_cart_icon_margin_right
  },
  secondaryActions: {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
  },
  secondaryAction: {
    float: 'right',
    color: '#2b8eb0',
    fontWeight: 600,
    cursor: 'pointer',
    margin: '0 0.5rem 0 1rem'
  },
  disclaimer: {
    float: 'left',
    width: '100%',
    textAlign: 'left',
    fontWeight: '500',
    margin: '1rem 0',
    fontStyle: 'oblique'
  },
  loadScreen: {
    top: '20em'
  },
  inputGroup: {
    padding: '0.3rem 0'
  },
  ...modalStyles()
});

class Gallery extends React.Component {
  constructor(props) {
    super(props);

    const { screen } = props;

    this.state = {
      loading: true,
      showPurchaseModal: false,
      showPurchaseDisabledModal: false,
      showPriceGuide: false,
      showPrintSizeSelection: false,
      screen: screen || GALLERY_SCREEN,
      processingKnockout: false,
      galleryKey: Math.random(),
      showDiscountDialog: false
    }
  }

  componentDidMount() {
    const { user } = this.props;

    if (user) {
      this.setState({ loading: false });
      this.loadSelectedPrintSizes();
      trackEvent('Kiosk.LoadGallery', {
        userId: user.id,
        storyId: user.story_id,
        moments: this.props.moments.map(m => m.id)
      });
    }
  }

  loadSelectedPrintSizes() {
    const { user, getSelectedPrintSizes } = this.props;
    return getSelectedPrintSizes(user.story_id);
  }

  viewCatalog() {
    const {
      settings,
      user,
      viewCatalog
    } = this.props;

    viewCatalog();

    trackEvent('Kiosk.ViewCatalog', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token
    });
  }

  viewCartScreen() {
    const { selectedCount } = this.props;

    if (selectedCount) {
      this.props.setScrollPosition(window.scrollY);
      this.setState({ screen: CART_SCREEN, galleryKey: Math.random() }, () => {
        window.scrollTo(0, 0);
      });
    }
  }

  viewGalleryScreen() {
    this.setState({ screen: GALLERY_SCREEN, galleryKey: Math.random() }, () => {
      window.scrollTo(0, this.props.scrollPosition);
    });
  }

  allSelected() {
    const {
      selectedMomentIds,
      availableMomentIds
    } = this.props;

    let missing = false;
    for (let momentId of availableMomentIds) {
      if (selectedMomentIds.indexOf(momentId) === -1) {
        missing = true;
        break;
      }
    }

    return !missing;
  }

  toggleSelectAll() {
    if (this.allSelected()) {
      this.unselectAll();
    } else {
      this.selectAll();
    }
  }

  selectAll() {
    const {
      settings,
      user,
      selectMoments,
      availableMomentIds
    } = this.props;

    selectMoments(user.story_id, availableMomentIds);

    trackEvent('Kiosk.SelectAllCartItems', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token
    });
  }

  unselectAll() {
    const {
      settings,
      user,
      unselectMoments,
      availableMomentIds
    } = this.props;

    unselectMoments(user.story_id, availableMomentIds);

    trackEvent('Kiosk.UnselectAllCartItems', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token
    });
  }

  showPriceGuide() {
    this.setState({ showPriceGuide: true });
  }

  closePriceGuide() {
    if (this.state.showPriceGuide) {
      this.setState({ showPriceGuide: false });
      window.currentModal.close();
      document.body.style.overflowY = 'auto';
    }
  }

  closePrintSizeSelection() {
    window.currentModal && window.currentModal.close();
    setTimeout(() => {
      this.setState({ showPrintSizeSelection: false });
      document.body.style.overflowY = 'auto';
    }, 500);
  }

  showPurchaseModal() {
    const { selectedCount } = this.props;

    if (selectedCount > 0) {
      this.setState({ showPurchaseModal: true });
    } else {
      this.setState({ showPurchaseDisabledModal: true });
    }
  }

  closePurchaseModal() {
    this.setState({ showPurchaseModal: false });

    setTimeout(() => {
      this.props.clearPurchaseRequest();
    }, 500);
  }

  closePurchaseDisabledModal() {
    setTimeout(() => {
      this.setState({
        showPurchaseDisabledModal: false
      });
    }, 500);
  }

  showPrintSizeSelection() {
    this.setState({ showPrintSizeSelection: true });
  }

  async onSelect(momentId, purchased) {
    const {
      settings,
      user,
      selectMoments,
      setPhotoSwipeMoment
    } = this.props;

    setPhotoSwipeMoment({ id: momentId, purchased });
    await selectMoments(user.story_id, [momentId]);

    trackEvent('Kiosk.SelectCartItem', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token,
      momentId
    });
  }

  async onUnselect(momentId) {
    const {
      settings,
      user,
      unselectMoments,
      unselectKioskMoment
    } = this.props;

    await unselectMoments(user.story_id, [momentId]);

    trackEvent('Kiosk.UnselectCartItem', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token,
      momentId
    });

    // if there is no gallery screen, and only the catalog & cart screens,
    // then unselect the image from the catalog.
    if (settings.catalog_screen && !settings.gallery_screen) {
      await unselectKioskMoment(settings.token, user.story_id, momentId);

      trackEvent('Kiosk.UnselectImage', {
        userId: user.id,
        storyId: user.story_id,
        kiosk: settings.token,
        momentId
      });
    }
  }

  removeImage(momentId) {
    const {
      settings,
      user,
      removeMoment
    } = this.props;

    return removeMoment(user.story_id, momentId)
      .then(() => {
        trackEvent('Kiosk.RemoveImage', {
          userId: user.id,
          storyId: user.story_id,
          kiosk: settings.token,
          momentId: momentId
        });
      });
  }

  toggleCart() {
    if (this.state.showCart) {
      this.hideCart();
    } else {
      this.showCart();
    }
  }

  isLegacyTheme() {
    const { settings: { theme } } = this.props;
    return theme === LEGACY_THEME || theme === CLUBMED_THEME;
  }

  getNextButtonClass() {
    const { classes } = this.props;

    if (this.isLegacyTheme()) {
      return classes.completePurchaseButton;
    } else {
      return classes.completePurchaseButton2;
    }
  }

  getNextButtonLabel() {
    const { settings } = this.props;
    const { screen } = this.state;

    let label;
    switch (screen) {
      case GALLERY_SCREEN:
        if (settings.cart_screen) {
          label = messages.button_review_and_purchase;
        } else {
          label = messages.button_complete_purchase;
        }
        break;

      case CART_SCREEN:
        label = messages.button_complete_purchase;
    }

    return <FormattedMessage {...label} />
  }

  getNextButtonAction() {
    const { settings } = this.props;
    const { screen } = this.state;

    switch (screen) {
      case GALLERY_SCREEN:
        if (settings.cart_screen) {
          return () => this.viewCartScreen();
        } else {
          return () => this.showPurchaseModal();
        }

      case CART_SCREEN:
        return () => this.showPurchaseModal();
    }
  }

  getNextButton() {
    const { user, selectedPrintMomentIds } = this.props;
    let btnClass = this.getNextButtonClass();

    // if unlock all has been activated, then allow user to buy more prints.
    // if no prints are selected then just show the View Receipt button
    let showViewReceipt = user.unlocked && selectedPrintMomentIds.length === 0;

    let btnLabel, btnAction;
    if (showViewReceipt) {
      btnLabel = <FormattedMessage {...messages.button_view_receipt} />;
      btnAction = () => this.props.viewReceipt();
    } else {
      btnLabel = this.getNextButtonLabel();
      btnAction = this.getNextButtonAction();
    }

    return (
      <button className={btnClass} onClick={btnAction}>
        {btnLabel}
      </button>
    );
  }

  getPrintSizesButton() {
    const { classes, selectedPrintSizes } = this.props;
    let totalPrints = 0;
    let btnLabel, btnAction;

    for (let printSize of selectedPrintSizes) {
      totalPrints += printSize.print_count;
    }

    btnLabel = <FormattedMessage {...withValues(messages.button_selected_print_sizes, { quantity: totalPrints })} />
    btnAction = () => this.showPrintSizeSelection();

    return (
      <button className={classes.printSizeButton} onClick={btnAction}>
        {btnLabel}
      </button>
    );
  }

  getBackButtonStyle() {
    const { settings } = this.props;

    if (settings.theme === CLUBMED_THEME) {
      return {
        fontSize: '1.2rem',
        boxShadow: '0 0 0 8px #2b8eb0'
      }
    } else {
      return null;
    }
  }

  getBackButtonLabel() {
    const { settings } = this.props;
    const { screen } = this.state;
    const clubMed = settings.theme === CLUBMED_THEME;

    let label;
    switch (screen) {
      case GALLERY_SCREEN:
        if (settings.catalog_screen) {
          if (clubMed) {
            label = messages.button_more_images;
          } else {
            label = messages.button_add_more_images;
          }
        } else {
          // there is no previous page
          return null;
        }
        break;

      case CART_SCREEN:
        if (settings.gallery_screen) {
          if (clubMed) {
            label = messages.button_view_my_gallery;
          } else {
            label = messages.button_view_gallery;
          }
        } else if (settings.catalog_screen) {
          label = messages.button_add_more_images;
        } else {
          // only the cart screen is enabled. this isn't a valid configuration
          return null;
        }
    }

    return <FormattedMessage {...label} />;
  }

  getBackButtonAction() {
    const { settings } = this.props;
    const { screen } = this.state;

    switch (screen) {
      case GALLERY_SCREEN:
        if (settings.catalog_screen) {
          return () => this.viewCatalog();
        } else {
          // there is no previous screen
          return null;
        }

      case CART_SCREEN:
        if (settings.gallery_screen) {
          return () => this.viewGalleryScreen();
        } else if (settings.catalog_screen) {
          return () => this.viewCatalog();
        } else {
          // to have only a cart screen isn't a working configuration,
          // but leaving this here for clarity
          return null
        }
    }
  }

  getBackButton() {
    const { classes, settings } = this.props;
    const { screen } = this.state;

    // if this is the gallery screen and there's no catalog screen,
    // then there is no back button
    if (screen === GALLERY_SCREEN && !settings.catalog_screen) {
      return null;
    }

    let btnStyle = this.getBackButtonStyle();
    let btnLabel = this.getBackButtonLabel();
    let btnAction = this.getBackButtonAction();

    return (
      <button className={classes.addImagesButton} style={btnStyle} onClick={btnAction}>
        {btnLabel}
      </button>
    );
  }

  getCartIconClass() {
    const { classes } = this.props;

    if (this.isLegacyTheme()) {
      return classes.cartCount;
    } else {
      return classes.cartCount2;
    }
  }

  getCartIconLabel() {
    const { selectedMomentIds, selectedPrintMomentIds, selectedCount } = this.props;

    if (this.isLegacyTheme()) {
      // selectedCount is the number of images selected for digital, print or both (merged total)
      return <span>{selectedCount}</span>;

    } else {
      let imageCount = selectedMomentIds.length;
      let printCount = selectedPrintMomentIds.length;

      return <FormattedMessage {...withValues(messages.kiosk_cart_count_verbose, { imageCount, printCount })} />;
    }
  }

  getCartIconAction() {
    const { settings } = this.props;
    const { screen } = this.state;

    if (!settings.gallery_screen || !settings.cart_screen) {
      return null;
    }

    switch (screen) {
      case GALLERY_SCREEN:
        return () => this.viewCartScreen();

      case CART_SCREEN:
        return () => this.viewGalleryScreen();
    }
  }

  getCartIcon() {
    const { classes, settings, user } = this.props;

    // there is no cart icon once all images have been unlocked,
    // unless prints are enabled
    if (user.unlocked && !settings.print_mode) {
      return null;
    }

    let iconClass = this.getCartIconClass();
    let iconLabel = this.getCartIconLabel();
    let iconAction = this.getCartIconAction();

    return (
      <p className={iconClass} onClick={iconAction}>
        {iconLabel}
        <ShoppingCartIcon className={classes.cartIcon} />
      </p>
    )
  }

  getGalleryIcon() {
    const { classes, settings, moments } = this.props;

    // currently the gallery icon is only being shown for legacy themes.
    // it might be good to implement it for newer themes when both
    // the gallery and cart screens are being used, so that the user
    // can see the number of total images in addition to the those selected
    if (!this.isLegacyTheme() || !settings.gallery_screen) {
      return null;
    }

    let imageCount = moments.length;

    return (
      <p className={classes.cartCount}>
        <span>{imageCount}</span>
        <PhotoLibraryIcon className={classes.cartIcon} />
      </p>
    );
  }

  getHeader() {
    const { classes, settings, user } = this.props;
    const { screen } = this.state;

    let msg;
    switch (screen) {
      case GALLERY_SCREEN:
        if (user.unlocked) {
          msg = messages.kiosk_gallery_header_unlocked;
        } else if (settings.theme === CLUBMED_THEME) {
          msg = messages.kiosk_gallery_header_clubmed;
        } else {
          msg = messages.kiosk_gallery_header;
        }
        break;

      case CART_SCREEN:
        msg = messages.kiosk_cart_header;
    }

    return (
      <p className={classes.panelHeader} style={{ margin: '0 0 0.5rem 0' }}>
        <FormattedMessage {...msg} />
      </p>
    );
  }

  getInstructions() {
    const { classes, settings, user } = this.props;
    const { screen } = this.state;

    let msg;
    switch (screen) {
      case GALLERY_SCREEN:
        if (user.unlocked) {
          if (settings.prints_enabled) {
            msg = messages.kiosk_gallery_instructions_unlocked_prints;
          } else {
            msg = messages.kiosk_gallery_instructions_unlocked;
          }

        } else {
          let buttonLabel = this.getNextButtonLabel();

          if (settings.prints_enabled) {
            msg = withValues(messages.kiosk_gallery_instructions_prints, { buttonLabel });
          } else {
            msg = withValues(messages.kiosk_gallery_instructions, { buttonLabel });
          }
        }
        break;

      case CART_SCREEN:
        msg = messages.kiosk_cart_instructions;
    }

    return (
      <p className={classes.tapMessage}>
        <FormattedMessage {...msg} />
      </p>
    );
  }

  selectEnabled() {
    const { screen } = this.state;

    switch (screen) {
      case GALLERY_SCREEN:
        return true;

      case CART_SCREEN:
        return false;
    }
  }

  selectAllEnabled() {
    // select all is disabled after unlock all
    const { user } = this.props;
    return this.selectEnabled() && !user.unlocked;
  }

  printsEnabled() {
    const { settings: { print_mode, checkout_type } } = this.props;

    // only allow prints in haggle mode (prints pricing not configurable by marketplace)
    return print_mode && checkout_type !== MARKETPLACE_CHECKOUT_TYPE;
  }

  getImageGalleryHeader() {
    const { settings } = this.props;
    const { screen } = this.state;

    let msg;
    switch (screen) {
      case GALLERY_SCREEN:
        if (settings.theme === CLUBMED_THEME) {
          msg = messages.kiosk_images_header_clubmed;
        } else {
          msg = messages.kiosk_images_header;
        }
        break;

      case CART_SCREEN:
        msg = messages.kiosk_images_header_selected;
    }

    return <FormattedMessage {...msg} />
  }

  getImageGallery() {
    const { classes, settings, selectedMomentIds } = this.props;
    const { screen } = this.state;

    let header = this.getImageGalleryHeader();
    let width = this.orderDetailsEnabled() ? '72vw' : '100vw';
    let selectEnabled = this.selectEnabled();
    let selectAllEnabled = this.selectAllEnabled();
    let printsEnabled = this.printsEnabled();

    // if gallery screen, then show all story moments
    // and remove image from story upon removal.
    // if cart screen, then show selected moments
    // and unselect image upon removal
    let moments, removeEnabled, removeImage, showRemoveModal, viewImageOnTap, cart;
    switch (screen) {
      case GALLERY_SCREEN:
        moments = this.props.moments;
        viewImageOnTap = false; // will default to toggling selection

        // only enable removing image if catalog screen is enabled
        if (settings.catalog_screen) {
          removeEnabled = true;
          removeImage = this.removeImage.bind(this);
          showRemoveModal = true;
        }
        break;

      case CART_SCREEN:
        moments = this.props.selectedMoments;
        viewImageOnTap = true; // unselecting causes the image to vanish
        removeEnabled = true;
        removeImage = this.onUnselect.bind(this);
        showRemoveModal = false;
        cart = true;
    }

    let fontColor = null;
    // disabling for legacy themes for now, this can be folded into config
    if (!this.isLegacyTheme()) {
      fontColor = config.kiosk_toolbar_header_font_color;
    }

    return (
      <div className={classes.momentsPanel} style={{ width }}>
        <Viewport>
          <ImageGalleryContainer
            header={header}
            columns={3}
            width={width}
            moments={moments}
            selectedMomentIds={selectedMomentIds}
            resolution={1}
            selectEnabled={selectEnabled}
            onSelect={this.onSelect.bind(this)}
            onUnselect={this.onUnselect.bind(this)}
            showSelectAll={selectAllEnabled}
            toggleSelectAll={() => this.toggleSelectAll()}
            allSelected={() => this.allSelected()}
            printsEnabled={printsEnabled}
            removeEnabled={removeEnabled}
            removeImage={removeImage}
            showRemoveModal={showRemoveModal}
            viewImageOnTap={viewImageOnTap}
            cart={cart}
            showDates={settings.show_dates}
            showCountByDate={false}
            fontColor={fontColor}
            selectCartItem={true}
            galleryWorker={this.props.galleryWorker}
            galleryKey={this.state.galleryKey}
          />
        </Viewport>
      </div>
    );
  }

  getCurrencyIcon() {
    const { classes, settings } = this.props;
    const currencySign = getCurrencySign(settings.currency);

    if (currencySign !== '$') {
      return <span className={classes.priceGuideIcon} style={{ float: 'left', margin: '-0.25rem 0.5rem 0 0', fontWeight: 'bold', fontSize: '1.3rem' }}>{currencySign}</span>;
    }

    return <MonetizationOnIcon className={classes.priceGuideIcon} />;
  }

  priceGuideEnabled() {
    const { settings } = this.props;

    // price guide only enabled for marketplace checkout
    return settings.checkout_type === MARKETPLACE_CHECKOUT_TYPE;
  }

  discountCodeEnabled() {
    const { settings } = this.props;

    //discount only enabled for marketplace checkout
    return settings.checkout_type === MARKETPLACE_CHECKOUT_TYPE && settings.discount_codes;
  }

  getPriceGuideButton() {
    const { classes } = this.props;

    if (!this.priceGuideEnabled()) {
      return null;
    }

    let currencyIcon = this.getCurrencyIcon()

    return (
      <button className={classes.priceGuideButton} onClick={() => this.showPriceGuide()}>
        {currencyIcon}
        <FormattedMessage {...messages.button_price_guide} />
      </button>
    );
  }

  getDiscountCodeButton() {
    const { classes } = this.props;

    if (!this.discountCodeEnabled()) {
      return null;
    }

    return (
      <button className={classes.priceGuideButton} onClick={() => this.setState({ showDiscountDialog: true })}>
        <NewReleasesIcon className={classes.discountIcon} />
        Apply Discount
      </button>
    );
  }

  orderDetailsEnabled() {
    const { settings, user } = this.props;

    return user && !user.unlocked && !settings.hide_order_details;
  }

  getOrderDetails() {
    const { classes } = this.props;

    if (!this.orderDetailsEnabled()) {
      return null;
    }

    let showPriceGuide = this.priceGuideEnabled();

    return (
      <div className={classes.orderPanel}>
        <div className={classes.orderPanelContainer}>
          <p className={classes.panelHeader}>
            <FormattedMessage {...messages.kiosk_order_details_header} />
          </p>
          <PurchaseDetails hideHeader={true} showPriceGuide={showPriceGuide} />
          <p className={classes.disclaimer}>
            <FormattedMessage {...messages.kiosk_order_details_disclaimer_no_refunds} />
          </p>
        </div>
      </div>
    );
  }

  reknockOutAction() {
    const { reKnockOutMoment, reKnockOutMomentId, settings, user, getMoments } = this.props;
    this.setState({ processingKnockout: true });
    reKnockOutMoment(reKnockOutMomentId, settings.token).then(() => {
      this.setState({ processingKnockout: false });
      getMoments(settings.token, user.story_id, { includePurchased: true }).then(() => {
        this.setState({ galleryKey: Math.random() });
      });
    }).catch((ex) => {
      this.setState({ processingKnockout: false });
      let errMsg = "An unknown error occurred";
      if (ex.error) {
        errMsg = ex.error

        // Custom message for knockout request timeouts
        if (errMsg.includes("Client.Timeout exceeded while awaiting headers")) {
          errMsg = "API request failed: Client timeout exceeded"
        }
      }
      window.alert(errMsg)
    })
  }

  render() {
    // this will render either the gallery or cart screen,
    // which are mostly the same structure.
    // individual components change based on the screen and kiosk settings
    const { classes, user, selectedPrintSizes, settings, getMoments, showCropMoment, showPrintSizeEdits, cropMoment } = this.props;

    if (this.state.loading) {
      return (<Loading />);
    }

    if (!user) {
      return null;
    }

    let header = this.getHeader();
    let instructions = this.getInstructions();
    let nextButton = this.getNextButton();
    let printSizeButton = this.getPrintSizesButton();
    let backButton = this.getBackButton();
    let cartIcon = this.getCartIcon();
    let galleryIcon = this.getGalleryIcon();
    let priceGuideBtn = this.getPriceGuideButton();
    let orderDetails = this.getOrderDetails();
    let imageGallery = this.getImageGallery();
    let discountButton = this.getDiscountCodeButton();

    return (
      <div className={classes.viewport}>
        <div className={classes.toolbar}>
          <div className={classes.toolbarLeftColumn}>
            {header}
            {instructions}
          </div>
          <div className={classes.actions}>
            <div style={{ float: 'right', cursor: 'pointer' }}>
              {nextButton}
              {cartIcon}
              {galleryIcon}
            </div>
            {backButton}
            {priceGuideBtn}
            {discountButton}
            {
              selectedPrintSizes.length > 0 && printSizeButton
            }
          </div>
          <div className={classes.secondaryActions}>
          </div>
        </div>
        {imageGallery}
        {orderDetails}
        <PurchaseModal open={this.state.showPurchaseModal} onClose={() => this.closePurchaseModal()} />
        <PurchaseDisabledModal open={this.state.showPurchaseDisabledModal} onClose={() => this.closePurchaseDisabledModal()} />
        <PriceGuide open={this.state.showPriceGuide} onClose={() => this.closePriceGuide()} />
        <AuthorizePinDialog open={this.props.authorizeKnockOutVisible} approvedAction={this.reknockOutAction.bind(this)}
          onClose={() => this.props.showAuthorizeKnockout(false, 0)} />
        <Dimmer active={this.state.processingKnockout}>
          <Loader active={this.state.processingKnockout} >Processing re-knockout moment...</Loader>
        </Dimmer>
        <SelectedPrintsPreviewModal isOpen={this.state.showPrintSizeSelection} onClose={() => this.closePrintSizeSelection()} />
        <PrintSizeEditsDialog onClose={() => { showPrintSizeEdits(false, null) }} />
        <DiscountCodeModal isOpen={this.state.showDiscountDialog} onClose={() => { this.setState({ showDiscountDialog: false }) }} />
        <ImageCropDialog onClose={(reload) => {
          if (reload) {
            getMoments(settings.token, user.story_id, { includePurchased: true }).then(() => {
              showCropMoment(false, cropMoment);
              this.setState({ galleryKey: Math.random() })
            });
          } else {
            showCropMoment(false, cropMoment);
          }
        }} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  user: state.kioskReducer.user,
  moments: getCartMoments(state),
  selectedMoments: getSelectedMoments(state),
  selectedMomentIds: state.cartReducer.selectedMomentIds,
  selectedPrintMomentIds: state.cartReducer.selectedPrintMomentIds,
  selectedCount: getSelectedCount(state),
  scrollPosition: state.kioskReducer.scrollPosition,
  availableMomentIds: getAvailableMomentIds(state),
  selectedPrintSizes: state.cartReducer.selectedPrintSizes,
  cropMomentVisible: state.photoSwipeReducer.cropMomentVisible,
  authorizeKnockOutVisible: state.photoSwipeReducer.authorizeKnockOutVisible,
  reKnockOutMomentId: state.photoSwipeReducer.reKnockOutMomentId,
  cropMoment: state.photoSwipeReducer.cropMoment
});

export default connect(mapStateToProps, { getMoments, reKnockOutMoment, showAuthorizeKnockout, viewCatalog, viewReceipt, setPhotoSwipeMoment, removeMoment, selectMoments, unselectMoments, clearPurchaseRequest, setScrollPosition, unselectKioskMoment, getSelectedPrintSizes, showCropMoment, showPrintSizeEdits })(withStyles(styles)(Gallery));

